import { useEffect, useState } from "react";

export default function StrategyDraftControls({ selectedStrategyCode, preview, drafts = [], editingDraft, onEditDraft, onSaveDraft, onActivateDraft, onSimulateDraft, simulatingDraftCode, simulation, saving }) {
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [summary, setSummary] = useState("");
  useEffect(() => {
    if (!editingDraft) return;
    setName(editingDraft.strategyName ?? "");
    setCode(editingDraft.strategyCode ?? "");
    setSummary(editingDraft.strategySummary ?? "");
  }, [editingDraft]);
  const updateName = (value) => {
    setName(value);
    if (!code) setCode(value.trim().replace(/[^a-zA-Z0-9]+/g, "_").replace(/^_+|_+$/g, "").toUpperCase());
  };
  return <details className="advanced-signal-rules" open>
    <summary><span>04</span><strong>Save New Strategy</strong></summary>
    <div className="strategy-draft-panel">
      <div className="signal-decision-strip">
        <div><span>Base Strategy</span><strong>{selectedStrategyCode}</strong></div>
        <div><span>Preview Candidates</span><strong>{preview?.candidateCount ?? "Run check"}</strong></div>
        <div><span>Core Rejections</span><strong>{preview?.coreRuleRejectedCount ?? "-"}</strong></div>
      </div>
      <div className="strategy-draft-form">
        <label>Strategy name<input value={name} onChange={(event) => updateName(event.target.value)} /></label>
        <label>Strategy code<input value={code} onChange={(event) => setCode(event.target.value.toUpperCase())} /></label>
        <label>Summary<input value={summary} onChange={(event) => setSummary(event.target.value)} /></label>
        <button type="button" className="refresh-btn" disabled={!preview || !name || !code || saving}
          onClick={() => onSaveDraft?.({ strategyName: name, strategyCode: code, strategySummary: summary })}>
          {saving ? "Saving" : editingDraft ? "Update Draft" : "Save as Draft"}
        </button>
      </div>
      {drafts.map((draft) => <div className="strategy-draft-row" key={draft.strategyCode}>
        <span>{draft.strategyName} ({draft.strategyCode})</span>
        <span className="strategy-draft-actions">
          <button type="button" onClick={() => onEditDraft?.(draft.strategyCode)}>Edit</button>
          <button type="button" onClick={() => onSimulateDraft?.(draft.strategyCode)} disabled={Boolean(simulatingDraftCode)}>
            {simulatingDraftCode === draft.strategyCode ? "Running short trial..." : "Run Short Trial"}
          </button>
          <button type="button" onClick={() => onActivateDraft?.(draft.strategyCode)}>Activate</button>
        </span>
      </div>)}
      {simulation && <section className="draft-simulation-results" aria-live="polite">
        <div className="draft-simulation-heading">
          <div><span>{simulation.quoteMode === "LIVE" ? "Live NSE simulation" : "Completed-session simulation"}</span><strong>{simulation.strategyCode} · {simulation.marketDate}</strong></div>
          <strong>{simulation.decisionCounts?.BEARISH_CANDIDATE ?? 0} bearish candidates</strong>
        </div>
        <div className="signal-decision-strip">
          <div><span>Evaluated</span><strong>{simulation.candidateCount ?? 0}</strong></div>
          <div><span>Bearish</span><strong>{simulation.decisionCounts?.BEARISH_CANDIDATE ?? 0}</strong></div>
          <div><span>Bullish</span><strong>{simulation.decisionCounts?.BULLISH_CANDIDATE ?? 0}</strong></div>
          <div><span>Waiting</span><strong>{simulation.decisionCounts?.WAIT ?? 0}</strong></div>
          <div><span>Unavailable</span><strong>{simulation.statusCounts?.UNDER_CHECKING ?? 0}</strong></div>
        </div>
        <p className="draft-simulation-note">{simulation.quoteMode === "LIVE"
          ? "Manual, read-only check using the current NSE session. Re-run it for refreshed prices."
          : "Manual, read-only check using the latest completed NSE session. Candidates require fresh-session confirmation before entry."}</p>
        <div className="guide-table-wrap">
          <table className="guide-table draft-simulation-table">
            <thead><tr><th>Stock</th><th>Close</th><th>Open</th><th>Change</th><th>Volume</th><th>Status</th></tr></thead>
            <tbody>
              {(simulation.candidates ?? []).filter((candidate) => candidate.liveDecision === "BEARISH_CANDIDATE").map((candidate) => (
                <tr key={candidate.symbol}>
                  <td><strong>{candidate.symbol}</strong><small>{candidate.companyName}</small></td>
                  <td>{candidate.liveLtp?.toFixed?.(2) ?? "-"}</td>
                  <td>{candidate.liveOpen?.toFixed?.(2) ?? "-"}</td>
                  <td>{candidate.livePercentChange != null ? `${candidate.livePercentChange.toFixed(2)}%` : "-"}</td>
                  <td>{candidate.liveVolume?.toLocaleString?.() ?? "-"}</td>
                  <td>Watch for breakdown</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>}
    </div>
  </details>;
}
